export const APP_NAME = 'Spaces For you';
export const APP_TAGLINE = 'Inclusive Spaces. Safer Experiences. Creative Connections.';
export const APP_DESCRIPTION =
  'Discover, book, and host inclusive creative venues across Kenya. Safer experiences for everyone.';

export const SUPPORT_EMAIL = 'support@spaces.co.ke';
export const SUPPORT_PHONE = '+254 18 705 129';
export const COMPANY_LOCATION = 'Nairobi, Kenya';

export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/spaces',
  twitter: 'https://twitter.com/spaces',
  facebook: 'https://facebook.com/spaces',
  linkedin: 'https://linkedin.com/company/spaces',
} as const;

export const CITIES = ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret'] as const;

export const VENUE_TYPES = [
  'Event Hall',
  'Restaurant',
  'Studio Space',
  'Outdoor Space',
  'Conference Room',
  'Art Gallery',
  'Theater',
  'Community Center',
  'Rooftop',
  'Garden',
] as const;

export const MOODS = ['Intimate', 'Energetic', 'Relaxed', 'Creative'] as const;

export const TIMES_OF_DAY = ['Morning', 'Afternoon', 'Evening'] as const;

export const NOISE_LEVELS = ['Quiet', 'Moderate', 'Loud'] as const;

export const EVENT_CATEGORIES = [
  'Community & Safe Space Events',
  'Creative & Culture Events',
  'Performance & Entertainment',
  'Food & Drink Experiences',
  'Life & Milestone Events',
  'Social & Private Celebrations',
  'Work, Learning & Professional',
  'Intimate & Experiential Gatherings',
  'Content & Media Creation',
] as const;
